module.exports = __webpack_public_path__ + "img/a14.e1cfbf5b.svg";